import { render, staticRenderFns } from "./AdminStrains.vue?vue&type=template&id=f1ad3450"
import script from "./AdminStrains.vue?vue&type=script&lang=js"
export * from "./AdminStrains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ad3450')) {
      api.createRecord('f1ad3450', component.options)
    } else {
      api.reload('f1ad3450', component.options)
    }
    module.hot.accept("./AdminStrains.vue?vue&type=template&id=f1ad3450", function () {
      api.rerender('f1ad3450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminStrains.vue"
export default component.exports